<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        发现好货
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <!-- <router-link to="./c_integralAdd" tag="div" class="center_list_head_rig">添加商品</router-link> -->
          <div class="center_list_head_rig" @click="dialogFormVisible1 = true">添加商品</div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <!-- <el-table-column label width="40" v-model="select" type="selection"></el-table-column> -->
        <el-table-column prop="id" width="260" label="编号" align="center"></el-table-column>
        <el-table-column prop="title" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="order" label="排序" align="center"></el-table-column>
        <el-table-column prop="classification" width="170" label="分类" align="center"></el-table-column>

        <!-- @change="status($event,scope.row.id)" -->

        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button class="button1" @click="del(scope.row.id)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="2" style="padding-left:10px;">
            <!-- <el-checkbox v-model="selectAll" style="line-height: 34px">全选</el-checkbox> -->
          </el-col>
          <el-col :span="8"></el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 编辑 -->
    <el-dialog title="添加商品" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="排序:">
          <el-input style="width:356px" v-model="order" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　id:">
          <el-input style="width:356px" v-model="p_id" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      order: "",
      p_id: "",
      surplus_number: "",
      integral: "",
      title: "",
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      mobile: "",
      create_time: "",
      nickname: "",
      odd: "",
      password: "",
      password1: "",
      value2: true,
      dialogFormVisible1: false,
      id: "",
      mobile: "",
      number: "",
      name: "",
      value1: "",
      resType: null,
      option: [],
      category: null,
      categorys: [],
      brand: null,
      brands: [],
      tableData: [],
      multipleSelection: [],
      isIndeterminate: true,
      select: false,
      selectAll: false,
      checked: [],
      idString: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 5;
    this.$store.state.leftTitle = "发现好货";
    this.geting();
  },
  watch: {
    //监听全选状态
    selectAll(v) {
      if (v == false) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleAllSelection();
      }
    }
  },
  methods: {
    shipments(id) {
      //确认发货弹窗

      const _this = this;
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit() {
      //编辑弹窗提交
      this.axios
        .get(this.serve + "/admin/add_find_good", {
          params: {
            username: this.username,
            token: this.token,
            p_id: this.p_id,
            order: this.order
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible1 = false;
            this.geting();
            this.$message({
              //成功时 返回的状态
              message: "添加成功",
              type: "success"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    red(id) {
      this.id = id;
      this.dialogFormVisible1 = true;
      this.axios
        .get(this.serve + "/admin/edit_integral", {
          params: {
            username: this.username,
            token: this.token,
            integral_id: id
          }
        })
        .then(res => {
          var json = res.data.data;
          if (res.data.status == "success") {
            this.title = json.title;
            this.integral = json.integral;
            this.surplus_number = json.surplus_number;
          }
        });
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/del_find_good", {
              params: {
                username: this.username,
                token: this.token,
                p_id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting();
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg); 
              }
            });
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: "已取消删除"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },

    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },

    geting(page) {
      //请求数据
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/find_good_list", {
          params: {
            token: this.token,
            username: this.username,
            page: page
          }
        })
        .then(res => {
          this.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            this.total = json.total;
            this.page = json.page;
            this.tableData = json.results;
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>